<template>
  <v-container id="table-extrato" class="pa-0 mt-0">
    <v-col class="d-flex justify-end pb-2 px-0" cols="12">
        <v-btn color="primary" text @click="getFile()" :disabled="list.length == 0">
          <v-icon small class="pr-2">fa-download</v-icon>
          Exportar 
        </v-btn>
      </v-col>
      <v-row
        class="ma-0 pl-4 pr-2" 
        style="background-color: #d1dcea; margin-bottom: 10px !important;">
        <v-col cols="2" class="pa-4">
          <div class="px-5 pt-1">
            <b class="pr-2">TOTAIS</b>
          </div>
        </v-col>
        <v-col cols="10" class="pa-0">
          <v-row class="ma-0 pt-1 pr-2" style="justify-content: end;">
            <v-spacer/>
            <v-col class="text-list text-right px-0 py-1" style="max-width:11.6%">
              <small>Vl. faturado:</small><br />
              <b><span>{{ totais.valor_informado_conciliado | formatPrice }}</span></b>
            </v-col>
            <v-col class="text-list text-right px-0 py-1" style="max-width:11.6%">
              <small>Vl. pago bruto:</small><br />
              <b><span style="color: rgb(50, 184, 139)">{{ totais.valor_liberado | formatPrice }}</span></b>
            </v-col>
            <v-col class="text-list text-right px-0 py-1" style="max-width:11.6%">
              <small>Vl. pago liquido:</small><br />
              <b><span style="color: rgb(50, 184, 139)">{{ totais.valor_pago_liquido | formatPrice }}</span></b>
            </v-col>
            <v-col class="text-list text-right px-0 py-1" style="max-width:11.6%">
              <small>Vl. imposto:</small><br />
              <b><span style="color: red; font-weight: 400;">{{ totais.valor_imposto | formatPrice }}</span></b>
            </v-col>
            <v-col class="text-list text-right px-0 py-1" style="max-width:11.6%">
              <small>Vl. desconto:</small><br />
              <b><span style="color: red; font-weight: 400;">{{ totais.valor_desconto | formatPrice }}</span></b>
            </v-col>
          </v-row>  
        </v-col>              
      </v-row>
    <v-data-table
      dense
      hide-default-footer
      :headers="headers"
      :items="list"
      :items-per-page="-1"
      ref="guiasListTable"
      class="lotesListTable"
      @update:options="ordenacao"
    >
      <template v-slot:header >
        <thead class="v-data-table-header" >
          <tr>
            <th colspan="4" style="border-bottom: none; text-align: center">Informações gerais</th>
            <th colspan="2" style="border-bottom: none; text-align: center">Dados do pagamento</th>
            <th colspan="3" style="border-bottom: none; text-align: center">Dados da quitação</th>
          </tr>
        </thead>
      </template>
      <template v-slot:item.data_quitacao="{ item }">
        {{ item.data_quitacao | formatDate }}
      </template>
      <template v-slot:item.data_pagamento="{ item }">
        {{ item.data_pagamento | formatDate }}
      </template>

      <template v-slot:item.valor_informado_conciliado="{ item }">
        <b v-if="item.valor_informado_conciliado">{{ item.valor_informado_conciliado | formatPrice}}</b>
      </template>
      <template v-slot:item.valor_liberado="{ item }">
        <b style="color:#32B88B" v-if="item.valor_liberado">{{ item.valor_liberado | formatPrice }}</b>
      </template>

      <template v-slot:item.valor_pago_liquido="{ item }">
        <b style="color:#32B88B" v-if="item.valor_pago_liquido">{{ item.valor_pago_liquido | formatPrice }}</b>
      </template>
      <template v-slot:item.valor_imposto="{ item }">
        <span style="color:#D0021B" v-if="item.valor_imposto">{{ item.valor_imposto | formatPrice }}</span>
      </template>
      <template v-slot:item.valor_desconto="{ item }">
        <span style="color:#D0021B" v-if="item.valor_desconto">{{ item.valor_desconto | formatPrice }}</span>
      </template>
      
    </v-data-table>
    <p class="text-right"><small>Valores em Reais (R$)</small></p>
    <v-row>
      <v-col cols="4"></v-col>
      <v-col class="text-center mt-2 py-0" cols="4">
        <v-pagination
          class="no-box-shadow"
          v-model="pagination.offset"
          :length="pagination.total_pages"
          @input="getList(filterData, pagination.offset)"
        ></v-pagination>
      </v-col>
      <v-col cols="4"></v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment"
moment.locale('pt-BR');
export default {
  data() {
    return {
       headers: [
        { text: "Data da Quitação", value: "data_quitacao", align: "center", class:"pa-2", sortable: true },
        { text: "Data do Pgto", value: "data_pagamento", align: "center", class:"pa-2", sortable: true },
        { text: "Operadora", value: "oper_nome", align: "left", class:"pa-2", sortable: true },
        { text: "Prestador", value: "prest_nome", align: "left", class:"pa-2", sortable: true },

        { text: "Vl. faturado", value: "valor_informado_conciliado", align: "right", class:"pa-1", sortable: true },
        { text: "Vl. pago bruto", value: "valor_liberado", align: "right", class:"pa-2", sortable: true },

        { text: "Vl. pago liquido", value: "valor_pago_liquido", align: "right", class:"pa-2", sortable: true },
        { text: "Vl. imposto", value: "valor_imposto", align: "right", class:"pa-2", width:"10%", sortable: true },
        { text: "Vl. desconto", value: "valor_desconto", align: "right", class:"pa-2", width:"10%", sortable: true },
       
      ],
    }
  },
  filters: {
    formatDate(date) {
      return moment(date).format("L");
    },
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }
  },
  watch: {
    selectedGuias(val) {
      this.selectGuias(val)
    },
    list(list) {
      if (list) {
        setTimeout(() => {
          let index = list.reduce((total, elem, ind) => { if(elem.is_editada){ total.push(ind) } return total }, [])
          index.forEach( el => this.$refs['guiasListTable'].$el.getElementsByTagName('tbody')[0].getElementsByTagName('tr')[el].setAttribute('class', 'active'))
        },500)
      }
    }
  },
  methods: {
    getStatusData(id, param){
      let status = this.statusList.find(el=> el.id == id)
      return status? status[param] : ''
    },
    selecionaTodos(selection) {
      if (selection.value) {
        this.selectedGuias = [...selection.items];
      } else {
        this.selectedGuias = [];
      }
    },
    selecaoUnica(selection) {
      if (selection.value) {
          this.selectedGuias.push(selection.item);
      } else {
        let ind = this.selectedGuias.findIndex( item => item == selection.item)
        this.selectedGuias.splice(ind, 1)
      }
    },
    ordenacao(item) {
      let sort = item.sortBy[0] ? item.sortBy[0] : null;
      let order = item.sortDesc.length > 0 ? (item.sortDesc[0] ? "Desc": "Asc") : null;
      let newFilter = {...this.filterData, sort, order}
      this.getList(newFilter, 1)
    },
  },
  props: {
    getList: Function,
    list: Array,
    pagination: Object,
    filterData: Object,
    getFile: Function,
    statusList: Array,
    totais: Object
  },
}
</script>

<style lang="scss">
#table-extrato {
  .no-box-shadow, .no-box-shadow *{
    box-shadow: 0 0 0 0!important;
  }
  .theme--light.v-data-table.lotesListTable   .v-icon.v-icon {
    font-size: 13px !important;
  }
}
</style>